import BottomTab from "../../../components/common/bottom-tab";
import Menu from "../components/menu";
import Header from "../../../components/common/header";

const Policy = () => {
  return (
    <div className="w-full h-[100vh] flex flex-col">
      {/* 헤더 */}
      <Header title="약관 및 정책" showBackButton />

      {/* 메뉴   */}
      <div className="flex-1 overflow-y-auto">
        <Menu
          title="이용약관 (소비자용)"
          to="https://subsequent-frog.super.site/%EC%9D%B4%EC%9A%A9%EC%95%BD%EA%B4%80-%EC%86%8C%EB%B9%84%EC%9E%90%EC%9A%A9"
        />
        <Menu
          title="이용약관 (공급자용)"
          to="https://trapezoidal-hamburger-538.notion.site/29608e6e11b38040b202ec9c5bb6bf09"
        />
        <Menu
          title="개인정보처리방침"
          to="https://subsequent-frog.super.site/29608e6e11b3800e8d73f172bb194d07"
        />
        <Menu
          title="개인정보 수집·이용 동의서"
          to="https://subsequent-frog.super.site/%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%88%98%EC%A7%91%EC%9D%B4%EC%9A%A9-%EB%8F%99%EC%9D%98%EC%84%9C"
        />
        <Menu
          title="위치기반 서비스 이용약관"
          to="https://subsequent-frog.super.site/%EC%9C%84%EC%B9%98%EA%B8%B0%EB%B0%98-%EC%84%9C%EB%B9%84%EC%8A%A4-%EC%9D%B4%EC%9A%A9%EC%95%BD%EA%B4%80"
        />
        <Menu
          title="위치정보 수집·이용 동의"
          to="https://subsequent-frog.super.site/%EC%9C%84%EC%B9%98%EC%A0%95%EB%B3%B4-%EC%88%98%EC%A7%91%EC%9D%B4%EC%9A%A9-%EB%8F%99%EC%9D%98"
        />
        <Menu
          title="결제 및 환불 정책"
          to="https://subsequent-frog.super.site/%EA%B2%B0%EC%A0%9C-%EB%B0%8F-%ED%99%98%EB%B6%88-%EC%A0%95%EC%B1%85"
        />
        <Menu title="쿠폰 이용정책" to="/my/policy/coupon" />
        <Menu
          title="마케팅 정보 수신 동의서"
          to="https://subsequent-frog.super.site/%EB%A7%88%EC%BC%80%ED%8C%85-%EC%A0%95%EB%B3%B4-%EC%88%98%EC%8B%A0-%EB%8F%99%EC%9D%98%EC%84%9C"
        />
      </div>

      <BottomTab />
    </div>
  );
};

export default Policy;
